import {
  Anchor,
  Badge,
  Box,
  Group,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../../_base/component/_layout/_breadcrumb";
import { useHomeBlockStore } from "../../store/useHomeBlockStore";
import {
  COMMON_FIELDS,
  designImage,
  HomeBlockTemplate,
  TEMPLATES,
} from "./homeBlockData";
import classes from "./homeBlock.module.css";

const HomeBlockTemplates = () => {
  const blocks = useHomeBlockStore((s) => s.blocks);
  const load = useHomeBlockStore((s) => s.load);

  // Link "Xem trình sửa mẫu này" cần block thật trong danh sách
  useEffect(() => {
    load();
  }, [load]);
  const sampleBlockId = (key: HomeBlockTemplate) =>
    blocks.find((b) => b.template === key)?.id;

  return (
    <Box className={classes.page}>
      <BreadCrumb />
      <Stack gap={20} mt={8}>
        <Stack gap={6} miw={0}>
          <Anchor
            component={Link}
            to="/fixed-content/home-block"
            fz={13}
            fw={600}
            underline="never"
            c="var(--hb-accent)"
          >
            <Group gap={6}>
              <IconArrowLeft size={16} />
              Quay lại danh sách block
            </Group>
          </Anchor>
          <Title order={1} fz={26} lh={1.2}>
            Mẫu block và trường cấu hình
          </Title>
          <Text fz={14} className={classes.muted} maw="72ch">
            20 block cấu hình được trên trang chủ dùng chung 13 mẫu. Mỗi mẫu có
            một trình sửa riêng; nguồn dữ liệu ưu tiên lấy từ các màn đã có
            trong Web Manager thay vì nhập lại. Menu đầu trang, Flash Sale và
            chân trang là phần cố định, không có mẫu ở đây.
          </Text>
        </Stack>

        <Paper
          withBorder
          radius="md"
          px={20}
          py={18}
          component="section"
          aria-labelledby="hb-common-title"
        >
          <Text
            id="hb-common-title"
            component="h2"
            fz={16}
            fw={700}
            m={0}
            mb={12}
          >
            Trường chung cho mọi block
          </Text>
          <SimpleGrid
            cols={{ base: 1, sm: 2, md: 3, lg: 5 }}
            spacing={24}
            verticalSpacing={12}
          >
            {COMMON_FIELDS.map((f) => (
              <Box key={f.title}>
                <Text fz={14} fw={600} lh={1.3}>
                  {f.title}
                </Text>
                <Text fz={13} lh={1.45} mt={4} c="var(--hb-ink-2)">
                  {f.desc}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </Paper>

        <SimpleGrid
          cols={{ base: 1, md: 2, xl: 3 }}
          spacing={16}
          style={{ alignItems: "start" }}
        >
          {TEMPLATES.map((t) => {
            const editId = t.hasEditor ? sampleBlockId(t.key) : undefined;
            return (
              <Paper
                key={t.key}
                withBorder
                radius="md"
                component="article"
                style={{ overflow: "hidden" }}
              >
                <Group
                  gap={12}
                  wrap="nowrap"
                  px={16}
                  py={14}
                  style={{ borderBottom: "1px solid var(--hb-border)" }}
                >
                  <img
                    src={designImage(t.thumbId, 480)}
                    alt=""
                    referrerPolicy="no-referrer"
                    loading="lazy"
                    style={{
                      display: "block",
                      width: 112,
                      height: 56,
                      objectFit: "cover",
                      objectPosition: "top left",
                      border: "1px solid var(--hb-border)",
                      borderRadius: 4,
                      flex: "none",
                    }}
                  />
                  <Stack gap={6} miw={0}>
                    <Text component="h2" fz={16} fw={700} lh={1.25} m={0}>
                      {t.name}
                    </Text>
                    <Badge
                      variant="light"
                      color="gray"
                      radius="xl"
                      tt="none"
                      fw={600}
                      style={{ alignSelf: "flex-start", maxWidth: "100%" }}
                    >
                      {t.used}
                    </Badge>
                  </Stack>
                </Group>
                <Stack gap={10} px={16} py={14}>
                  {t.groups.map((g) => (
                    <Box key={g.title}>
                      <Text fz={13} fw={600} lh={1.35}>
                        {g.title}
                      </Text>
                      <Text fz={13} lh={1.45} mt={2} c="var(--hb-ink-2)">
                        {g.fields}
                      </Text>
                      {g.source && (
                        <Text fz={12} lh={1.4} mt={3} c="var(--hb-accent-ink)">
                          Nguồn: {g.source}
                        </Text>
                      )}
                    </Box>
                  ))}
                  {editId && (
                    <Anchor
                      component={Link}
                      to={`/fixed-content/home-block/${editId}`}
                      fz={13}
                      fw={600}
                      underline="never"
                      c="var(--hb-accent)"
                    >
                      Xem trình sửa mẫu này
                    </Anchor>
                  )}
                </Stack>
              </Paper>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Box>
  );
};

export default HomeBlockTemplates;
